import { ExportSquare } from 'iconsax-react'
import React from 'react'

import type { IImageFindings } from '@/store/api/Person/Person.types'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'
import { useTranslation } from 'react-i18next'

interface FaceMatchWidgetTypes {
  matches: IImageFindings[]
}
export const FaceMatchWidget = ({ matches }: FaceMatchWidgetTypes) => {
  const { t } = useTranslation()
  return (
    <div className="p-4 flex flex-col gap-4 bg-baseColor rounded-xl">
      <div className="flex flex-col gap-1">
        <p className="text-neutralColor text-xl font-medium">
          {t('report.generalInfo.faceMatch.title')}
        </p>
        <p className="text-neutralColor80 text-base font-normal">
          {t('report.generalInfo.faceMatch.description')}
        </p>
      </div>
      <div
        className={`flex gap-4 flex-wrap ${
          matches.length > 2 ? 'justify-between' : 'justify-start'
        }`}
      >
        {matches.map((match, index) => (
          <div
            key={index}
            className="relative flex w-[31.5%] max-sm:w-full max-lg:w-[48%] h-80 rounded-2xl overflow-hidden bg-cover bg-center transition-transform duration-300"
            style={{ backgroundImage: `url(${match.image})` }}
          >
            <ExportSquare
              size="18"
              color={SocialMirrorPalette.primary}
              className="absolute top-4 right-4 cursor-pointer hover:scale-125 transition-transform duration-300 hover:opacity-90"
              onClick={() => window.open(match.url, '_blank')}
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/60 to-transparent p-4">
              <div className="flex flex-col gap-1 text-white">
                <p className="text-lg font-bold text-staticWhite">{`${match.score}% Match`}</p>
                <p className="text-xs font-normal truncate opacity-90 text-staticWhite">
                  {match.url}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
